'use client'

import { createContext, useContext } from 'react'

import type { ProductPayments } from '@/entities/Payments/model/types/PaymentSchema'

import type { ServerResponse } from '@/shared/types/common'
import type { TServiceServer } from '@/shared/types/deprecated-types'

/**
 * Non-personalized product data prefetched on the server (page.tsx) and passed to the client as a
 * prop. Provided via context so the consuming hooks read it synchronously on BOTH the server and the
 * client's first render — the tree renders identically (no hydration mismatch), the content ships in
 * the SSR HTML, and the hooks `skip` their RTK Query request (no post-hydration waterfall).
 * Personalized data (bonus/gift) is excluded (session-dependent); the product description is excluded
 * too — its CMS HTML doesn't survive SSR + browser innerHTML normalization identically.
 */
export type ProductSsrData = {
	productId: number
	services: TServiceServer | null
	payments: ServerResponse<ProductPayments> | null
}

const ProductSsrDataContext = createContext<ProductSsrData | null>(null)

export const ProductSsrDataProvider = ProductSsrDataContext.Provider

export const useProductSsrData = () => useContext(ProductSsrDataContext)
